/**
 * Toast notification type constants
 * Use these values to ensure type safety across the application
 */
export const ToastType = {
  SUCCESS: 'success',
  ERROR: 'error',
} as const;

/**
 * Toast notification type
 */
export type ToastType = (typeof ToastType)[keyof typeof ToastType];
